import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      dynamicReport: {
        SCORE_BAR: 'Score Bar',
        REPORT_PREVIEW: 'Report Preview',
        REPORT_PREVIEW_NOTE:
          'Drag and drop to rearrange display order of each panel. Click each panel to customize.',
        REMOVE_C_PANELS: 'Remove all (C) panels ',
        REMOVE_P_PANELS: 'Remove all (P) panels ',
        COVER_PAGE: 'Report Cover Page',
        REPORT_TEMPLATE_NAME: 'Report template name',
        CUSTOMIZE_REPORT: 'Customize Report',
        TAB_COMPANY: '(C) Company Analysis',
        TAB_PORTFOLIO: '(P) Portfolio',
        SEARCH_COMPANY: 'Search company',
        CHAPER_HEADER: 'Chapter Header',
        COMPANY_PROFILE: 'Company Profile',
        COMPANY_OVERVIEW: 'Company Overview',
        INDUSTRY_CLASSIFICATION: 'Industry Classification',
        BOARD_OF_MANAGEMENT: 'Board of Management',
        BOARD_OF_DIRECTOR: 'Board of Director',
        OWNERSHIP_AND_GROUP: 'Ownership & Group',
        OWNERSHIP_STRUCTURE: 'Ownership Structure',
        PARENT_COMPANIES: 'Parent Companies',
        BRANCHES: 'Branches',
        SUBSIDIARIES: 'Subsidiaries',
        ASSOCIATES: 'Associates',
        RELATED_COMPANIES: 'Related Companies',
        FINANCIAL_STATEMENT: 'Financial Statement',
        FINANCIAL_ANALYSIS: 'Financial Analysis',
        QUICK_ASSESSMENT: 'Quick Assessment',
        PROFITABILITY: 'Profitability',
        ROA_AND_ROE: 'ROA and ROE',
        ASSET_MANAGEMENT_EFFICIENCY: 'Asset Management Efficiency',
        LIQUIDITY: 'Liquidity',
        SOLVENCY: 'Solvency',
        COVERAGE: 'Coverage',
        BALANCE_SHEET_BREAKDOWN: 'Balance Sheet Breakdown',
        EARNINGS_BREAKDOWN: 'Earnings Breakdown',
        CASH_FLOW_STRUCTURE: 'Cash Flow Breakdown',
        LOAN_BOOK_BREAKDOWN_AND_COVERAGE: 'Loan Book Breakdown and Coverage',
        DEPOSIT_AND_CREDIT: 'Deposit and Credit',
        AVERAGE_COST: 'Average Cost of Financing and Credit Cost',
        EARNINGS_QUALITY: 'Earnings Quality',
        CAPITAL_AND_LEVERAGE: 'Capital and Leverage',
        FUNDING_STRUCTURE: 'Funding Structure',
        OPERATING_SALES: 'Operating Income',
        BUSINESS_POSITION: 'Business Position',
        FINANCIAL_ASSETS: 'Financial Assets',
        EARNING_QUALITY: 'Earning Quality',
        LEVERAGE: 'Leverage',
        FUNDING_AND_LIQUIDITY: 'Funding and Liquidity',
        SCORE: 'Score',
        CREDIT_RISK_SCORE: 'Corporate Risk Score',
        PERFORMANCE_SCORE: 'Corporate Performance Score',
        CORPORATE_LINKAGE_SCORE: 'Corporate Linkage Score',
        INDUSTRY_OVERVIEW: 'Industry Overview',
        MACROECONOMICS_GDP: 'Macroeconomics_GDP',
        MACROECONOMICS_FDI: 'Macroeconomics_FDI',
        MACROECONOMICS_IMPORT_EXPORT: 'Macroeconomics_Import-Export',
        TOP_INDUSTRY_PLAYERS: 'Top Industry Players',
        BUSINESS_ALLOCATION_BY_SIZE: 'Business Allocation by Size',
        BUSINESS_ALLOCATION_BY_AGE: 'Business Allocation by Age',
        BUSINESS_ALLOCATION_BY_OPERATING_STATUS:
          'Business Allocation by Operating Status',
        BUSINESS_ALLOCATION_BY_PROVINCE: 'Business Allocation by Province',
        INDUSTRY_SCALE: 'Industry Scale',
        INDUSTRY_ANALYSIS: 'Industry Analysis',
        INDUSTRY_MEDIAN_SCORE: 'Industry Median Score',
        LIQUIDITY_SOLVENCY_AND_COVERAGE: 'Liquidity, Solvency and Coverage',
        BUSINESS_GROWTH: 'Business Growth',
        CAPITAL_ADEQUACY: 'Capital Adequacy',
        ASSET_QUALITY: 'Asset Quality',
        CAPITAL_EARNING_AND_LEVERAGE: 'Capital, Earning and Leverage',
        PORTFOLIO_OVERVIEW: 'Portfolio Overview',
        TOP_10_HIGHEST_RISK: 'Top 10 Highest Risk',
        TOP_10_HIGHEST_RISK_SUB: '(Filters are not applied)',
        TOP_10_HIGHEST_GROWTH_POTENTIAL: 'Top 10 Highest Growth Potential',
        TOP_10_HIGHEST_GROWTH_POTENTIAL_SUB: '(Filters are not applied)',
        FINANCE: 'Portfolio by Finance',
        SCORE_2: 'Portfolio by Score',
        RISK_TREND: 'Risk Trend',
        PORTFOLIO_DISTRIBUTION: 'Portfolio Distribution By Corporate Risk',
        TOP_10_COMPANIES: 'Top 10 Companies by Risk Trends',
        CREDIT_SCORE_TREND: 'Credit Score Trend by Portfolio',
        PERFORMANCE_TREND: 'Performance Trend',
        PORTFOLIO_DISTRIBUTION_BY_GROWTH_POTENTIAL:
          'Portfolio Distribution by Growth Potential',
        TOP_10_COMPANIES_BY_GROWTH_POTENTIAL:
          'Top 10 Companies by Growth Potential',
        PERFORMANCE_SCORE_TREND: 'Performance Score Trend by Portfolio',
        SEGMENT: 'Portfolio by Segment',
        PORTFOLIO_ALLOCATION_BY_PROVINCE: 'Portfolio Allocation by Province',
        PORTFOLIO_ALLOCATION_BY_INDUSTRY: 'Portfolio Allocation by Industry',
        BUSINESS_SIZE_DISTRIBUTION: 'Business Size Distribution',
        YEARS_OF_OPERATION_DISTRIBUTION: 'Years in Operation Distribution',
        CORPORATE: 'Corporate',
        BANK: 'Bank',
        SECURITY: 'Securities',
        TOOLTIP_CHAPPER_HEADER: 'Dividing your report into chapters',
        CONFIRM: 'Confirmation',
        DISCARD: 'Discard',
        CHANGE_COMPANY_TYPE_ALERT:
          'Are you sure you want to change the Company Type? Any Financial analysis, Industry analysis and Score settings tied to your current type will be erased upon making this change.',
        PANEL_NAME: 'Panel name:',
        Trend: 'Trend',
        'Each year': 'Each year',
        Table: 'Table',
        Chart: 'Chart',
        PLH_NOTE: 'Enter text here',
        NOTE: 'Note',
        MAX_NOTE_CHARACTER: '1300 characters limit',
        MAX_NOTE_PANEL: '3500 characters limit',
        MAX_REPORT_TITLE_CHARACTER: '150 characters limit',
        REPORT_TITLE: 'Report Title',
        SUBTITLE: 'Subtitle',
        PANEL_SETTING_NOTE:
          'Select at least 1 option below to display them on your report.',
        BLANK_TEMPLATE: 'Blank Template',
        RESET: 'Reset',
        RESET_NOTE:
          'Reset this template will discard all changes. Do you want to continue?',
        EXIT: 'Exit',
        PREVIEW: 'Preview',
        EXPORT_REPORT: 'Export Report',
        PLEASE_WAIT: 'Please wait!',
        CANCEL_PDF: 'Cancel',
        TITLE_DOWNLOAD: 'Export your Dynamic Reports',
        TITLE_PREVIEW: 'Preview your Dynamic Reports',
        SELECT_DOWNLOAD:
          'Select types of language, currency and unit for your report:',
        LANGUAGE: 'Language',
        CURRENCY: 'Currency',
        UNIT: 'Unit',
        SUBMIT_EXPORT: 'Export report',
        EN: 'English',
        VI: 'Vietnamese',
        DISCLAIMER_TITLE: 'Disclaimer',
        DISCLAIMER_1:
          'This Dynamic Report (hereinafter referred to as “Report”) is owned and prepared by Vietnam FiinGroup Joint Stock Company (hereinafter referred to as “FiinGroup”). The information recorded in the Report is provided for the confidential and exclusive use of the Subscriber/User (hereinafter referred to as “Subscriber”) and/or their customers on the condition that FiinGroup shall not be liable for any claim, loss, injury or damage suffered by the recording of incorrect, incomplete, inaccurate, or out-of-date information.',
        DISCLAIMER_2:
          'The Report is furnished by FiinGroup in STRICT CONFIDENTIAL at your request for your exclusive use. The Report is not intended to be used as the sole basis for any business decision and is based upon data which is provided by sources believed to be reliable. Although every effort has been made by FiinGroup to ensure the accuracy of the report contents, and FiinGroup makes no representation or warranty regarding the accuracy and completeness of such information. The information in the Report shall not be revealed, supplied, copied, or displayed in any form, nor made known to the Subject Business Entity (hereinafter referred to as “SBE”), nor any other party without prior written authorization from FiinGroup. The Subscriber will be liable to indemnify FiinGroup for any loss, damage, or expense incurred as a result of breach or non-observance of any of these conditions.',
        DISCLAIMER_3:
          'Copyright © 2022 by Vietnam FiinGroup JSC. All rights reserved.',
        TITLE_REPORT: 'FiinGate Dynamic Report',
        DATE_OF_REPORT: 'Date of Report: ',
        HEAD_OFFICE: 'Head Office',
        HN_ADDRESS:
          'Level 10, Peakview Tower, 36 Hoang Cau, O Cho Dua Ward, Hanoi, Vietnam',
        HCM_BRANCH: 'Ho Chi Minh Branch',
        HCM_ADDRESS:
          'Suite 1682, Level 16, Bitexco Financial Tower, 2 Hai Trieu Street, Sai Gon Ward, Ho Chi Minh City, Vietnam',
        TABLE_OF_CONTENT: 'TABLE OF CONTENTS',
        PHONE: 'T: ',
        EMAIL: 'E: ',
        MORE_AT: 'More at:',
        ENTER_PORTFOLIO_NAME: 'Enter Portfolio name',
        COMPARE_WITH: 'Compare with',
        TITLE_WARNING_EXPORT: 'Warning: Could not export report',
        CONTENT_WARNING_EXPORT:
          'Please select a company or portfolio to export this report.',
        TITLE_WARNING_PREVIEW: 'Warning: Could not preview report',
        CONTENT_WARNING_PREVIEW:
          'Please select a company or portfolio to preview this report.',
        SELECT_YEAR: 'Select year:',
        SELECT_INDICATOR: 'Select indicator:',
        YEAR_REPORT_WARNING: 'Please select a company before selecting years.',
        NOTE_BUY_FACTSHEET_1:
          "Please download this company's FiinGate Factsheet ",
        NOTE_BUY_FACTSHEET_2: 'here',
        NOTE_BUY_FACTSHEET_3: ' to create its dynamic report.',
        ADDITIONAL_FS: 'Additional currency for Financial statements',
        COMMENT: 'Comment:',
        BALANCE_SHEET: 'Balance sheet',
        INCOME_STATEMENT: 'Income statement',
        CASHFLOW_STATEMENT: 'Cashflow statement',
        BALANCE_SHEET_2: 'Balance Sheet',
        INCOME_STATEMENT_2: 'Income Statement',
        CASHFLOW_STATEMENT_2: 'Cashflow Statement',
        SETTING_FS_1: 'Setting Financial statements ',
        SETTING_FS_2: 'here',
        SETTING_FS_TITLE: 'Setting Financial Statements',
        SETTING_FS_NOTE_1:
          "You can select between different presentations of this Company's Financial Statements (FS) in ",
        SETTING_FS_NOTE_2: 'the FS tab',
        SETTING_FS_NOTE_3: ' in order to find out the best visualization.',
        SETTING_FS_NOTE_4:
          'You can also utilize our default filters for this company by clicking the button on the right corner. Financial data in this report is generated according to your selection.',
        SETTING_FS_WARNING:
          'Please select a company before setting Financial Statements.',
        KEEP_SETTING_TITLE: 'Create Dynamic Report',
        KEEP_SETTING_CONTENT:
          "Do you want to apply current platform's setting to your report?",
        YES: 'Yes',
        NO: 'No',
        WARNING_INDUSTRY_ANALYSIS:
          'Please select Industry for Industry Analysis function before taking any further actions.',
        OK: 'Ok',
        IN: 'In',
        NOTE_CURRENCY_UNIT:
          '(**) Note: The conversion of the financial indicators into USD/EUR is for your general reference only as it is not exactly complied with the accounting standards in the conversion of financial indicators from a local currency into a foreign currency.',
        NOTE_DELETE:
          'Are you sure you want to permanently delete these selected panels?',
        COMPANY_NAME: 'Company name',
        PORT_NAME: 'Portfolio name',
        COMPANY: 'Company',
        PORT: 'Portfolio',
        CORPORATE_RISK_SCORE: 'Corporate Risk Score',
        CORPORATE_PERFORMANCE_SCORE: 'Corporate Performance Score',
        RISK_SCALE_AND_INTERPRETATION: 'Risk Scale And Interpretation',
        RISK_COMPONENT_ANALYSIS: 'Risk Component Analysis',
        COMMENTARY: 'Commentary',
        FORWARD_LOOKING_PD_TERM_STRUCTURE: 'Forward Looking PD Term Structure',
        DISTRIBUTION_OF_SCORE: 'Distribution of Score',
        Map: 'Map',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      dynamicReport: {
        SCORE_BAR: 'Thang Điểm',
        REPORT_PREVIEW: 'Xem trước báo cáo',
        REPORT_PREVIEW_NOTE:
          'Kéo thả các mục để sắp xếp thứ tự hiển thị. Nhấp vào từng mục để tùy chỉnh.',
        REMOVE_C_PANELS: 'Xóa tất cả thông tin (C) ',
        REMOVE_P_PANELS: 'Xóa tất cả thông tin (P) ',
        COVER_PAGE: 'Trang bìa',
        REPORT_TEMPLATE_NAME: 'Tên mẫu báo cáo',
        CUSTOMIZE_REPORT: 'Tùy chỉnh báo cáo',
        TAB_COMPANY: '(C) Phân tích Công ty',
        TAB_PORTFOLIO: '(P) Phân tích danh mục',
        SEARCH_COMPANY: 'Tìm kiếm công ty',
        CHAPER_HEADER: 'Tiêu Đề Mục',
        COMPANY_PROFILE: 'Hồ Sơ Công Ty',
        COMPANY_OVERVIEW: 'Thông Tin Cơ Bản',
        INDUSTRY_CLASSIFICATION: 'Thông Tin Ngành',
        BOARD_OF_MANAGEMENT: 'Ban Lãnh Đạo',
        BOARD_OF_DIRECTOR: 'Hội Đồng Quản Trị',
        OWNERSHIP_AND_GROUP: 'Quan Hệ & Sở Hữu',
        OWNERSHIP_STRUCTURE: 'Cấu Trúc Sở Hữu',
        PARENT_COMPANIES: 'Công Ty Mẹ',
        BRANCHES: 'Chi Nhánh',
        SUBSIDIARIES: 'Công Ty Con',
        ASSOCIATES: 'Công Ty Liên Kết',
        RELATED_COMPANIES: 'Công Ty Liên Quan',
        FINANCIAL_STATEMENT: 'Báo Cáo Tài Chính',
        FINANCIAL_ANALYSIS: 'Phân Tích Tài Chính',
        QUICK_ASSESSMENT: 'Đánh Giá Nhanh',
        PROFITABILITY: 'Tỷ Suất Sinh Lời',
        ROA_AND_ROE: 'ROA và ROE',
        ASSET_MANAGEMENT_EFFICIENCY: 'Hiệu Quả Quản Lý Tài Sản',
        LIQUIDITY: 'Khả Năng Thanh Toán Nhanh',
        SOLVENCY: 'Khả Năng Thanh Toán Dài Hạn',
        COVERAGE: 'Khả Năng Thanh Toán Cổ Tức Và Lãi Vay',
        BALANCE_SHEET_BREAKDOWN: 'Cơ Cấu Bảng Cân Đối Kế Toán',
        EARNINGS_BREAKDOWN: 'Cơ Cấu Doanh Thu',
        CASH_FLOW_STRUCTURE: 'Cơ Cấu Dòng Tiền',
        LOAN_BOOK_BREAKDOWN_AND_COVERAGE:
          'Cơ Cấu Dư Nợ Cho Vay Và Khả Năng Thanh Toán',
        DEPOSIT_AND_CREDIT: 'Tiền Gửi và Tín Dụng',
        AVERAGE_COST: 'Lãi Suất Đầu Vào Bình Quân và Chi Phí Tín Dụng',
        EARNINGS_QUALITY: 'Chất Lượng Thu Nhập',
        CAPITAL_AND_LEVERAGE: 'Vốn và Đòn Bẩy Tài Chính',
        FUNDING_STRUCTURE: 'Cơ Cấu Vốn',
        OPERATING_SALES: 'Doanh Thu Hoạt Động',
        BUSINESS_POSITION: 'Vị Thế Trên Thị Trường',
        FINANCIAL_ASSETS: 'Tài Sản Tài Chính',
        EARNING_QUALITY: 'Chất Lượng Thu Nhập',
        LEVERAGE: 'Chỉ Số Đòn Bẩy',
        FUNDING_AND_LIQUIDITY: 'Cơ Cấu Vốn và Khả Năng Thanh Toán Nhanh',
        SCORE: 'Điểm Số',
        CREDIT_RISK_SCORE: 'Điểm Rủi Ro Tín Dụng Doanh Nghiệp',
        PERFORMANCE_SCORE: 'Điểm Triển Vọng Tăng Trường Doanh Nghiệp',
        CORPORATE_LINKAGE_SCORE: 'Điểm Số Các Doanh Nghiệp Có Liên Quan',
        INDUSTRY_OVERVIEW: 'Ngành',
        MACROECONOMICS_GDP: 'GDP',
        MACROECONOMICS_FDI: 'FDI',
        MACROECONOMICS_IMPORT_EXPORT: 'Xuất Nhập Khẩu',
        TOP_INDUSTRY_PLAYERS: 'Top Doanh Nghiệp Trong Ngành',
        BUSINESS_ALLOCATION_BY_SIZE: 'Tỷ Trọng Doanh Nghiệp Theo Quy Mô',
        BUSINESS_ALLOCATION_BY_AGE:
          'Tỷ Trọng Doanh Nghiệp Theo Số Năm Hoạt Động',
        BUSINESS_ALLOCATION_BY_OPERATING_STATUS:
          'Tỷ Trọng Doanh Nghiệp Theo Trạng Thái Hoạt Động',
        BUSINESS_ALLOCATION_BY_PROVINCE:
          'Tỷ Trọng Doanh Nghiệp Theo Tỉnh Thành',
        INDUSTRY_SCALE: 'Quy Mô Ngành',
        INDUSTRY_ANALYSIS: 'Phân Tích Ngành',
        INDUSTRY_MEDIAN_SCORE: 'Điểm Trung Vị Ngành',
        LIQUIDITY_SOLVENCY_AND_COVERAGE: 'Khả Năng Thanh Toán',
        BUSINESS_GROWTH: 'Khả Năng Tăng Trưởng',
        CAPITAL_ADEQUACY: 'Khả Năng Về Vốn',
        ASSET_QUALITY: 'Chất Lượng Tài Sản',
        CAPITAL_EARNING_AND_LEVERAGE: 'Tỷ Suất Sinh Lời',
        PORTFOLIO_OVERVIEW: 'Phân Bổ Danh Mục',
        TOP_10_HIGHEST_RISK: '10 Danh Mục, Ngành Có Rủi Ro Cao Nhất',
        TOP_10_HIGHEST_RISK_SUB: '(Không áp dụng bộ lọc)',
        TOP_10_HIGHEST_GROWTH_POTENTIAL:
          '10 Danh Mục, Ngành Có Tiềm Năng Tăng Trưởng Cao Nhất ',
        TOP_10_HIGHEST_GROWTH_POTENTIAL_SUB: '(Không áp dụng bộ lọc)',
        FINANCE: 'Thống Kê Danh Mục Theo Chỉ Tiêu Tài Chính',
        SCORE_2: 'Thống Kê Danh Mục Theo Điểm',
        RISK_TREND: 'Xu Hướng Rủi Ro',
        PORTFOLIO_DISTRIBUTION: 'Phân Bổ Danh Mục Theo Mức Rủi Ro Tín Dụng',
        TOP_10_COMPANIES: '10 Công Ty Đứng Đầu Theo Các Tiêu Chí Rủi Ro',
        CREDIT_SCORE_TREND: 'Xu Hướng Điểm Rủi Ro Tín Dụng Theo Danh Mục',
        PERFORMANCE_TREND: 'Xu Hướng Tiềm Năng Tăng Trưởng',
        PORTFOLIO_DISTRIBUTION_BY_GROWTH_POTENTIAL:
          'Phân Bổ Danh Mục Theo Mức Tiềm Năng Tăng Trưởng',
        TOP_10_COMPANIES_BY_GROWTH_POTENTIAL:
          '10 Công Ty Đứng Đầu Theo Các Tiêu Chí Tiềm Năng Tăng Trưởng',
        PERFORMANCE_SCORE_TREND:
          'Xu Hướng Điểm Triển Vọng Tăng Trưởng Theo Danh Mục',
        SEGMENT: 'Thống Kê Danh Mục Theo Yếu Tố Khác',
        PORTFOLIO_ALLOCATION_BY_PROVINCE: 'Phân Bổ Danh Mục Theo Địa Phận',
        PORTFOLIO_ALLOCATION_BY_INDUSTRY: 'Phân Bổ Danh Mục Theo Ngành',
        BUSINESS_SIZE_DISTRIBUTION: 'Phân Bổ Danh Mục Theo Quy Mô Doanh Thu',
        YEARS_OF_OPERATION_DISTRIBUTION:
          'Phân Bổ Danh Mục Theo Số Năm Hoạt Động',
        CORPORATE: 'Doanh Nghiệp',
        BANK: 'Ngân Hàng',
        SECURITY: 'Công Ty Chứng Khoán',
        TOOLTIP_CHAPPER_HEADER: 'Thêm đầu mục cho báo cáo',
        CONFIRM: 'Xác nhận',
        DISCARD: 'Loại Bỏ',
        CHANGE_COMPANY_TYPE_ALERT:
          'Thay đổi Loại Doanh Nghiệp sẽ loại bỏ các cài đặt liên quan đến Phân tích Tài chính, Phân tích Ngành và Điểm số. Bạn có muốn tiếp tục thực hiện thay đổi không?',
        PANEL_NAME: 'Tên hiển thị:',
        Trend: 'Tăng trưởng',
        'Each year': 'Năm',
        Table: 'Bảng',
        Chart: 'Đồ thị',
        PLH_NOTE: 'Nhập tại đây',
        NOTE: 'Chú thích',
        MAX_NOTE_CHARACTER: 'Tối đa 1300 ký tự',
        MAX_NOTE_PANEL: 'Tối đa 3500 ký tự',
        MAX_REPORT_TITLE_CHARACTER: 'Tối đa 150 ký tự',
        REPORT_TITLE: 'Tên báo cáo',
        SUBTITLE: 'Giới thiệu',
        PANEL_SETTING_NOTE:
          'Chọn ít nhất 1 nội dung để hiển thị trong báo cáo.',
        BLANK_TEMPLATE: 'Tạo mẫu mới',
        RESET: 'Đặt lại',
        RESET_NOTE:
          'Đặt lại mẫu báo cáo sẽ loại bỏ các thay đổi. Bạn có muốn tiếp tục không?',
        EXIT: 'Thoát',
        PREVIEW: 'Xem trước',
        EXPORT_REPORT: 'Xuất báo cáo',
        PLEASE_WAIT: 'Vui lòng chờ trong giây lát!',
        CANCEL_PDF: 'Hủy bỏ',
        TITLE_DOWNLOAD: 'Xuất Dynamic Report',
        TITLE_PREVIEW: 'Xem trước Dynamic Report',
        SELECT_DOWNLOAD: 'Chọn loại ngôn ngữ, tiền tệ và đơn vị cho báo cáo:',
        LANGUAGE: 'Ngôn ngữ',
        CURRENCY: 'Loại tiền tệ',
        UNIT: 'Đơn vị',
        SUBMIT_EXPORT: 'Xuất báo cáo',
        EN: 'Tiếng anh',
        VI: 'Tiếng việt',
        DISCLAIMER_TITLE: 'Từ chối trách nhiệm',
        DISCLAIMER_1:
          'Dynamic report này (sau đây gọi là “Báo cáo”) thuộc sở hữu và được lập bởi Công ty Cổ phần Tập đoàn FiinGroup Việt Nam (sau đây gọi là “FiinGroup”). Thông tin được ghi trong Báo cáo được cung cấp cho việc sử dụng bí mật và độc quyền của Người đăng ký/Người dùng (sau đây gọi là “Người đăng ký”) và/hoặc khách hàng của họ với điều kiện FiinGroup sẽ không chịu trách nhiệm cho bất kỳ khiếu nại, mất mát, tổn thất hoặc thiệt hại do thông tin không đúng, không đầy đủ, không chính xác hoặc không cập nhật.',
        DISCLAIMER_2:
          'Báo cáo được FiinGroup cung cấp ở chế độ BẢO MẬT NGHIÊM NGẶT theo yêu cầu của bạn để bạn sử dụng độc quyền. Báo cáo không nhằm mục đích sử dụng làm cơ sở duy nhất cho bất kỳ quyết định kinh doanh nào và dựa trên dữ liệu được cung cấp bởi các nguồn được cho là đáng tin cậy. Mặc dù FiinGroup đã nỗ lực hết sức để đảm bảo tính chính xác của nội dung báo cáo, tuy nhiên FiinGroup không đưa ra tuyên bố hay bảo đảm nào về tính chính xác và đầy đủ của những thông tin đó. Thông tin trong Báo cáo sẽ không được tiết lộ, cung cấp, sao chép hoặc hiển thị dưới bất kỳ hình thức nào, cũng như không được tiết lộ cho Đối tượng chủ thể kinh doanh (sau đây gọi là “SBE”), cũng như bất kỳ bên nào khác mà không có sự cho phép trước bằng văn bản của FiinGroup. Người đăng ký sẽ chịu trách nhiệm bồi thường cho FiinGroup về mọi tổn thất, thiệt hại hoặc chi phí phát sinh do vi phạm hoặc không tuân thủ bất kỳ điều khoản nào trong số này.',
        DISCLAIMER_3:
          'Copyright © 2022 by Vietnam FiinGroup JSC. Đã đăng ký Bản quyền.',
        TITLE_REPORT: 'Dynamic Report FiinGate',
        DATE_OF_REPORT: 'Ngày tạo: ',
        HEAD_OFFICE: 'Trụ Sở Chính',
        HN_ADDRESS:
          'Tầng 10, Tòa Nhà Peakview Tower, 36 Hoàng Cầu, Phường Ô Chợ Dừa, Thành phố Hà Nội, Việt Nam',
        HCM_BRANCH: 'Chi nhánh Tp.Hồ CHí Minh',
        HCM_ADDRESS:
          'Phòng 1682, Tầng 16, Tòa nhà Bitexco Financial Tower, số 2 đường Hải Triều, Phường Sài Gòn, TP Hồ Chí Minh, Việt Nam',
        TABLE_OF_CONTENT: 'MỤC LỤC',
        PHONE: 'Điện thoại: ',
        EMAIL: 'Email: ',
        MORE_AT: 'Xem thêm tại:',
        ENTER_PORTFOLIO_NAME: 'Nhập tên danh mục',
        COMPARE_WITH: 'So sánh với',
        TITLE_WARNING_EXPORT: 'Chú ý: Không xuất được báo cáo',
        CONTENT_WARNING_EXPORT:
          'Vui lòng chọn Công ty hoặc Danh mục để xuất báo cáo.',
        TITLE_WARNING_PREVIEW: 'Chú ý: Không thể xem trước báo cáo',
        CONTENT_WARNING_PREVIEW:
          'Vui lòng chọn Công ty hoặc Danh mục để xem trước báo cáo.',
        SELECT_YEAR: 'Chọn năm:',
        SELECT_INDICATOR: 'Chọn chỉ tiêu:',
        YEAR_REPORT_WARNING: 'Vui lòng chọn một công ty để đặt tùy chọn năm.',
        NOTE_BUY_FACTSHEET_1: 'Vui lòng tải FiinGate Factsheet ',
        NOTE_BUY_FACTSHEET_2: 'tại đây',
        NOTE_BUY_FACTSHEET_3: ' để tạo Dynamic Report cho công ty này.',
        ADDITIONAL_FS: 'Loại tiền tệ bổ sung cho BCTC',
        COMMENT: 'Nhận xét:',
        BALANCE_SHEET: 'Bảng cân đối kế toán',
        INCOME_STATEMENT: 'Báo cáo kết quả kinh doanh',
        CASHFLOW_STATEMENT: 'Báo cáo lưu chuyển tiền tệ',
        BALANCE_SHEET_2: 'Bảng Cân Đối Kế Toán',
        INCOME_STATEMENT_2: 'Báo Cáo Kết Quả Kinh Doanh',
        CASHFLOW_STATEMENT_2: 'Báo Cáo Lưu Chuyển Tiền Tệ',
        SETTING_FS_1: 'Tùy chỉnh báo cáo tài chính ',
        SETTING_FS_2: 'tại đây',
        SETTING_FS_TITLE: 'Tùy chỉnh Báo cáo tài chính',
        SETTING_FS_NOTE_1:
          'Bạn có thể chọn xem các cách thể hiện Báo cáo tài chính (BCTC) khác nhau của Công ty này trong ',
        SETTING_FS_NOTE_2: 'màn BCTC',
        SETTING_FS_NOTE_3: '.',
        SETTING_FS_NOTE_4:
          'Bạn cũng có thể sử dụng bộ cài đặt mặc định của FiinGate cho công ty này bằng cách nhấp vào nút ở góc bên phải. Dữ liệu tài chính trong báo cáo này được tạo theo tùy chỉnh của bạn.',
        SETTING_FS_WARNING:
          'Vui lòng chọn một công ty để tùy chỉnh Báo cáo tài chính.',
        KEEP_SETTING_TITLE: 'Tạo Dynamic Report',
        KEEP_SETTING_CONTENT:
          'Bạn có muốn tạo Dynamic Report dựa theo các cài đặt hiện tại trên màn hình?',
        YES: 'Có',
        NO: 'Không',
        WARNING_INDUSTRY_ANALYSIS:
          'Vui lòng chọn Ngành cho tính năng Phân Tích Ngành trước khi thực hiện các thao tác khác.',
        OK: 'Đồng ý',
        IN: 'Đơn vị:',
        NOTE_CURRENCY_UNIT:
          '(**) Lưu ý: Việc chuyển đổi chỉ tiêu tài chính sang USD/EUR chỉ mang tính chất tham khảo vì việc chuyển đổi các chỉ tiêu tài chính từ nội tệ sang ngoại tệ là chưa tuân thủ chính xác các chuẩn mực kế toán.',
        NOTE_DELETE:
          'Bạn có chắc chắn muốn xóa vĩnh viễn các mục được chọn không?',
        COMPANY_NAME: 'Tên công ty',
        PORT_NAME: 'Tên danh mục',
        COMPANY: 'Công ty',
        PORT: 'Danh mục',
        CORPORATE_RISK_SCORE: 'Điểm Rủi Ro Doanh Nghiệp',
        CORPORATE_PERFORMANCE_SCORE: 'Điểm Triển Vọng Tăng Trưởng Doanh Nghiệp',
        RISK_SCALE_AND_INTERPRETATION: 'Thang Điểm Và Diễn Giải Rủi Ro',
        RISK_COMPONENT_ANALYSIS: 'Phân Tích Thành Phần Và Nhân Tố Rủi Ro',
        COMMENTARY: 'Nhận Xét',
        FORWARD_LOOKING_PD_TERM_STRUCTURE:
          'Cấu Trúc Kỳ Hạn Của Xác Suất Vỡ Nợ Dự Báo',
        DISTRIBUTION_OF_SCORE: 'Phân Phối Điểm Số',
        Map: 'Bản đồ',
      },
    },
  }),
)
